
import './typography.scss';
import {
	CSSProperties,
	ReactNode,
} from 'react';

// TODO: Denne brukes midlertidig, til Karim dok'er ordentlig over hvem fonts ++ han bruker. Han fraviker ifra App.scss Tradesolution default
export enum TypographyType {
	headingsH1 = 'karim-headings-h1',
	headingsH3 = 'karim-headings-h3',
	headingsH4 = 'karim-headings-h4',
	headingsH5 = 'karim-headings-h5',
	textExtraSmallSemiBold = 'karim-text-extra-small-semi-bold',
	textBaseSemiBold = 'karim-text-base-semi-bold',
	karimTextCaptionRegular = 'karim-text-caption-regular',
	textCaptionBold = 'karim-text-caption-bold',
	textNormalRegular = 'karim-text-normal-regular',
	subtitle = 'karim-text-subtitle',
	button = 'karim-text-button-base',
	buttonSmall = 'karim-text-button-small',
	buttonLarge = 'karim-text-button-large',
}

interface TypographyProps {
	style?: CSSProperties;
	type: TypographyType;
	children:  JSX.Element | string | ReactNode;
	className?: string;
	center?: boolean;
}

const Typography = ({
	style,
	type = TypographyType.textNormalRegular,
	children,
	className,
	center = false,
}: TypographyProps) => {
	const classNames = `${type}${
		className ? ' ' + className : ''}${
		center ? ' text-align-center' : ''}`;

	switch (type) {
		case TypographyType.headingsH1:
			return (
				<h1 className={classNames} style={style}>
					{children}
				</h1>
			);
		case TypographyType.headingsH3:
			return (
				<h3 className={classNames} style={style}>
					{children}
				</h3>
			);
		case TypographyType.headingsH4:
			return (
				<h4 className={classNames} style={style}>
					{children}
				</h4>
			);
		case TypographyType.headingsH5:
			return (
				<h5 className={classNames} style={style}>
					{children}
				</h5>
			);
		default:
			return (
				<div className={classNames} style={style}>
					{children}
				</div>
			);
	}
};

export default Typography;

